import Input from './Input';

export default {
  baseStyle: Input.baseStyle?.field ?? {},
  variants: { primary: Input.variants?.primary.field ?? {} },
  defaultProps: { variant: 'primary' },
};
